export default {
  title: 'MRR-rapport',
  fields: {
    name: 'Naam',
    area: 'Gebied',
    mrr: 'MRR (netto)',
  },
  buttons: {
    download_report: 'Rapport downloaden',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt, vernieuw de pagina',
  },
};
